module.exports = __webpack_public_path__ + "img/35.81d506d3.jpg";